import React from 'react';
import { Spinner } from 'react-bootstrap';

export const SectionLoader: React.FC = () => (
  <div className="text-center">
    <Spinner animation="border" role="status" variant="light" size="sm" />
  </div>
);
